import React, { Component } from 'react';
import { Container, Row, Col, Form, Button, Modal } from 'react-bootstrap';
import { Bounce } from 'react-activity';
import ReCAPTCHA from "react-google-recaptcha";
import Backend from '../../Backend';
import ReactFlagsSelect from 'react-flags-select';
import ReactNotification from 'react-notifications-component';
import { store } from 'react-notifications-component';
import Countries from '../../Countries';
import NavbarEmptyComponent from '../NavbarEmpty';
import Connection from '../../Calls';

import es from '../../translate/es'
import en from '../../translate/en'

var countryForgot;

class ConfirmationIndex extends Component {
  constructor(props) {
    super(props)
    this.state = {
      reCaptcha: '',
      showload: false,
      email: '',
      token: '',
      aceptConfirm: false,
      showModal: false,
      showloadConfirm: false,
      emailConfirm: '',
      text:en

    }
  }

  componentWillMount() {
    var email = new window.URL(window.location.href).searchParams.get("email");
    var token = new window.URL(window.location.href).searchParams.get("token");
    this.setState({
      email: email,
      token: token
    });
    this.bQk7VZx7();

    if(localStorage.getItem('lan') == 'es')this.setState({text:es})
    else this.setState({text:en})

  }

  bQk7VZx7() {
    const self = this;
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XJPW023"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.bQk7VZx7(confirmation, date, result, "Bm3h642", combination, "XJPW023", response => {
      self.setState({
        vertice: response.payload.r03
      })
    });
  }

  onSelectFlag(countryCode) {
    var countrieSelect = Countries[countryCode];
    countryForgot = countrieSelect;
  }

  handleClose() {
    this.setState({ showModal: false });
  }

  handleShow() {
    this.setState({ showModal: true });
  }

  handleChange(value) {
    if (value !== null) {
      this.setState({ reCaptcha: "confirmed" });
    }
  }

  handleCheckbox(val) {
    const self = this;
    self.setState({ aceptConfirm: val.target.checked });
  }

  reenviarConfirmation() {
    const self = this;

    self.setState({ showloadConfirm: true });
    if (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.state.emailConfirm) !== false) {
      let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XWBX203"), latitude = "0", longitude = "0";
      let whiskas = Connection.RThzHrsb(self.state.emailConfirm)
      navigator.geolocation.getCurrentPosition((success, error, options) => {
        latitude = success.coords.latitude;
        longitude = success.coords.longitude
      });
      result = latitude + longitude;

      Connection.QCJQ7DUk(confirmation, date, result, "Apxm2aZ", combination, "XWBX203", "1", whiskas, response => {
        Backend.ResendConfirmation(self.state.emailConfirm, countryForgot, response.payload.r03, self.state.reCaptcha, response => {
          if (response.status.code === "0") {
            store.addNotification({
              title: "Success!",
              message: response.payload.message,
              type: "success",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 1800,
                onScreen: true
              }
            });
            self.setState({ countryConfirm: '', emailConfirm: '', key: '', reCaptcha: '', showloadConfirm: false });
            setTimeout(function () { self.props.data.history.push("/") }, 2000);
          } else {
            store.addNotification({
              title: "Error!",
              message: response.status.description,
              type: "danger",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 1800,
                onScreen: true
              }
            });
            self.setState({ showloadConfirm: false });
          }
        });
      });
    } else {
      store.addNotification({
        title: "Error!",
        message: "Email is bad formmated",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 1800,
          onScreen: true
        }
      });
      self.setState({ showloadConfirm: false });
    }
  }

  sendData() {
    const self = this;

    self.setState({ showload: true });
    if (this.state.reCaptcha !== "") {
      if (this.state.aceptConfirm !== "") {
        Backend.Confirmation(self.state.email, self.state.token, self.state.reCaptcha, response => {
          if (response.status.code === "0") {
            store.addNotification({
              title: "Success!",
              message: response.payload.message,
              type: "success",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 1800,
                onScreen: true
              }
            });
            self.setState({ reCaptcha: '', aceptConfirm: false, showload: false });
            setTimeout(function () { self.props.data.history.push("/") }, 2000);
          } else {
            store.addNotification({
              title: "Error!",
              message: response.status.description,
              type: "danger",
              insert: "top",
              container: "top-right",
              animationIn: ["animated", "fadeIn"],
              animationOut: ["animated", "fadeOut"],
              dismiss: {
                duration: 1800,
                onScreen: true
              }
            });
            self.setState({ showload: false });
          }
        });
      } else {
        store.addNotification({
          title: "Error!",
          message: "Check the confirmation",
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 1800,
            onScreen: true
          }
        });
        self.setState({ showload: false });
      }
    } else {
      store.addNotification({
        title: "Error!",
        message: "Verify the captcha",
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animated", "fadeIn"],
        animationOut: ["animated", "fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true
        }
      });
      self.setState({ showload: false });
    }
  }

  render() {
    return (
      <div>
        <NavbarEmptyComponent data={this.props} />
        <div className="contenedor-fondo-firebit">
          <Container fluid>
            <Row>
              <Col md={4} />
              <Col md={4}>
                <Container>
                  <Row className="container-signup">
                    <Col md={12}>
                      <div style={{ textAlign: "center" }}>
                        <p className="confirmation-title">{this.state.text.Register.confirmation.hi}, {this.state.email}</p>
                      </div>
                      <div className={"settings-boxes"}>
                        <Form.Check onChange={(e) => { this.handleCheckbox(e) }} inline label={this.state.text.Register.confirmation.yes} type={'checkbox'} id={"inline-'checkbox"} />
                      </div>
                      <div style={{ padding: 15, marginTop: 20 }}>
                        <center>
                          {
                            (this.state.vertice) &&
                            <ReCAPTCHA
                            theme="light"
                            sitekey={this.state.vertice}
                            onChange={this.handleChange.bind(this)}
                          />
                          }
                        </center>
                      </div>
                    </Col>
                    <Col md={12}>
                      <div style={{ marginTop: 15, textAlign: "center" }}>
                        <Button className="signup-button" variant="primary" onClick={() => { this.sendData() }} disabled={(!this.state.reCaptcha || !this.state.email || !this.state.aceptConfirm) ? true : false}>
                          {
                            (this.state.showload)
                              ? <Bounce size={20} color={"#FFFFFF"} animating={this.state.showload} />
                              : this.state.text.Register.confirmation.btn
                          }
                        </Button>
                      </div>
                      <div style={{ marginTop: 0, textAlign: "center" }}>
                        <Button className="label-signup-link" variant="link" onClick={() => { this.setState({ showModal: true }); }}>{this.state.text.Register.confirmation.link}</Button>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </Col>
              <Col md={4} />
            </Row>
          </Container>
          <Modal aria-labelledby="contained-modal-title-vcenter" centered show={this.state.showModal} onHide={() => { this.handleClose() }}>
            <Modal.Body>
              <div className="border-title-separator-container">
                <div className="border-title-separator-container-left" style={{ width: "100%" }}>
                  <p className="title-container-shadow">{this.state.text.Register.confirmation.M_title}</p>
                </div>
                {/* <div className="border-title-separator-container-right">
                <p className="subtitle-container-shadow">retrieve your confirmation link!.</p>
              </div> */}
              </div>
              <div>
                <Form.Group>
                  <Form.Label className="label-signup">{this.state.text.Register.confirmation.L_mail}</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder={this.state.text.Register.confirmation.P_mail}
                    className="input-signup"
                    value={this.state.emailConfirm}
                    onChange={(emailConfirm) => { this.setState({ emailConfirm: emailConfirm.target.value }) }}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label className="label-signup">{this.state.text.Register.confirmation.L_country}</Form.Label>
                  <ReactFlagsSelect
                    className="input-signup form-control"
                    searchable={true}
                    searchPlaceholder="Search for a country"
                    value={this.state.country}
                    onSelect={this.onSelectFlag}
                  />
                </Form.Group>
                <div>
                  <center style={{ marginBottom: 0 }}>
                    {
                      (this.state.vertice) &&
                      <ReCAPTCHA
                      theme="light"
                      sitekey={this.state.vertice}
                      onChange={this.handleChange.bind(this)}
                    />
                    }
                  </center>
                </div>
                <div>
                  <div style={{ marginTop: 30, textAlign: "center" }}>
                    <Button className="signup-button" variant="primary" onClick={() => { this.reenviarConfirmation() }} disabled={this.state.showloadConfirm}>
                      {
                        (this.state.showload)
                          ? <Bounce size={20} color={"#FFFFFF"} animating={this.state.showload} />
                          :this.state.text.Register.confirmation.M_btn
                      }
                    </Button>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>

        </div>
      </div>
    );
  }
} export default ConfirmationIndex;
